var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSorting(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24.013,
    viewBox: "0 0 24 24.013",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0.013)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#5d78ff",
    d: "M22,17v4a2,2,0,0,1-2,2H4a2,2,0,0,1-2-2V17H6.279l.544,1.632A2,2,0,0,0,8.721,20h6.661a2,2,0,0,0,1.789-1.106L18.118,17Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5d78ff",
    opacity: 0.3,
    d: "M2.563,15,5.927,9.019A2,2,0,0,1,7.67,8H16.33a2,2,0,0,1,1.743,1.019L21.438,15H18.118a2,2,0,0,0-1.789,1.106L15.382,18H8.721l-.544-1.632A2,2,0,0,0,6.279,15Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5d78ff",
    d: "M11.129.734V2.69H9.121a.5.5,0,0,0-.5.5V4.213a.5.5,0,0,0,.5.5h2.008V6.67a.5.5,0,0,0,.823.382l3.506-2.968a.5.5,0,0,0,0-.763L11.952.352a.5.5,0,0,0-.823.382Z",
    transform: "translate(8.298 15.621) rotate(-90)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSorting);
export default __webpack_public_path__ + "static/media/sorting.710244a055128e93c6e942a21931711d.svg";
export { ForwardRef as ReactComponent };